import http, { API_CORE } from '../http';

export default function CustomerBonusService() {
  const getCustomers = async (params = {}) => {
    const response = await http(API_CORE).get('/customer-bonus/customers', {
      params: params,
    });

    return response.data;
  };

  const getHistory = async (params = {}) => {
    const response = await http(API_CORE).get('/customer-bonus/history', {
      params: params,
    });

    return response.data;
  };

  const topUpBalance = async (params) => {
    const response = await http(API_CORE).put('/customer-bonus/balance/top-up', params);

    return response.data;
  };

  const chargeFromBalance = async (params) => {
    const response = await http(API_CORE).put('/customer-bonus/balance/charge', params);

    return response.data;
  };

  return {
    getCustomers,
    getHistory,
    topUpBalance,
    chargeFromBalance,
  };
}
